/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../Form";
import useForm from "../../../hooks/useForm";
import Modal, { ModalHeader } from "../../Modal";
import systemAlert from "../../../utils/systemAlert";
import { postConsultings, putConsultings } from "../../../apis/admin/consulting";
import { isEmpty } from "../../../utils/lodashExtend";
import { getCompainesManagers } from "../../../apis/companies/roles";
import { shallowEqual, useSelector } from "react-redux";
import { isObject } from "lodash";
import { CMS_REGISTRATION_FORM_URL } from "../../../utils/payPortal/cmsRegistration";

const defaultForm = {
  replyEmployee: null,
  replyEmployeeIdx: null,
  name: "",
  email: "",
  mobile: "",
  customerMemo: "",
  isAnswered: "대기중",
  description: "",
  fileIdxes: []
};


const CmsRegistrationForm = (props) => {

  const { company, employees } = useSelector((store) => ({
    company: store.Profile.company,
    employees: store.Data.employees,
  }), shallowEqual);
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create');
  const [taxCompanies, setTaxCompanies] = useState([]);

  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');

    if (open) {

      getCompainesManagers(2)
        .then(res => {

          setTaxCompanies([{ label: "선택안함", value: 'null' }, ...res.data.map(item => {
            return {
              ...item,
              value: item.idx,
              label: `${item.name} (${item.ceoName})`
            };
          })]);
        });
    }
    if (selectedItem) {

      setForm({
        ...selectedItem,
        ...(selectedItem?.demoPassword ? { expiredTime: selectedItem?.demoPassword?.expiredTime } : {}),
        replyEmployee: employees.filter((e) => e.idx === selectedItem.replyEmployeeIdx),
        isAnswered: selectedItem.isAnswered || '대기중',
        fileIdxes: selectedItem.uploadFiles,
      });
      setOriginForm({
        ...selectedItem,
        ...(selectedItem?.demoPassword ? { expiredTime: selectedItem?.demoPassword?.expiredTime } : {}),
        replyEmployee: employees.filter((e) => e.idx === selectedItem.replyEmployeeIdx),
        isAnswered: selectedItem.isAnswered || '대기중',
        fileIdxes: selectedItem.uploadFiles,
      });
    } else {
      const defaultFormData = {
        ...defaultForm,
        ...mode === 'create' ? {
          entryURL: '웹서비스 통한 문의',
          entryUrl: '웹서비스 통한 문의'
        } : {}
      };
      setForm(defaultFormData);
      setOriginForm(defaultFormData);
    }
  }, [open, selectedItem]);

  const _submit = (form) => {

    const data = {
      ...form,
      ...(!isEmpty(form.expiredTime) ? { expiredTime: `${form.expiredTime[0]} 00:00` } : {}),
      targetCompanyIdx: form.targetCompanyIdx === "null" ? null : isObject(form.targetCompanyIdx) ? form.targetCompanyIdx?.idx : form.targetCompanyIdx,
    };
    if (!isEmpty(data.replyEmployee)) {
      data.replyEmployeeIdx = data.replyEmployee[0].idx
    }


    if (mode === "create") {

      if (!data.targetCompanyIdx) {
        systemAlert(`요청세무사는 필수 입니다.`)
        return
      }
      systemAlert(`"${form.name}" 문의를 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              postConsultings(data)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    } else {
      systemAlert(`"${form.name}" 문의를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              putConsultings(selectedItem.consultingIdx, data)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {


    const taxCompany = taxCompanies.find(f => f.idx === form?.targetCompanyIdx);
    if (taxCompany && form.companyName) {
      setForm({ transferMessage: `"${form.companyName}"회사의 ${form?.consultingType} 요청이 "${taxCompany?.name}"에게 이관되었습니다.` });
    }

  }, [form.targetCompanyIdx, form.companyName]);


  useEffect(() => {
    setFields([
      [
        {
          title: "신청자",
          key: "name",
          type: "input",
          required: true,
        },
      ],
      [
        {
          title: "이메일",
          key: "email",
          type: "input",
          validators: ['email'],
          required: true,

        },
        {
          title: "연락처",
          key: "mobile",
          type: "input",
          validators: ['mobileWithAsterisk'],
          required: true,
        },
      ],
      [
        {
          title: "메모",
          key: "customerMemo",
          type: "textarea",
        },
      ],
    ]);

  }, [mode, form, taxCompanies, company]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write pay-registration">
        <ModalHeader>위케이크 CMS 신청{mode === "create" ? "하기" : "수정"}</ModalHeader>
        <div className="description">
          <strong className="">위케이크 CMS</strong>는 <strong className="color-purple-100">NICE 페이먼츠</strong>와의 제휴를 통해 세무사님들께 보다 저렴한 비용으로 서비스를 제공합니다.<br />
          따라서 <strong>사업자등록 정보는 반드시 세무사업</strong>으로 등록되어 있어야 합니다. <br /><br />
          PTC 정보를 변경하실 경우, 요금 혜택을 받을 수 없으며, 위케이크 서비스에서 이력 추적이 불가합니다.<br />
          신청서 접수 후 '접수 완료' 버튼을 눌러주시면, 이슈 발생 시 신속하게 연락드리겠습니다.
          <br />
          <br />
          <a href={CMS_REGISTRATION_FORM_URL}>
            CMS 신청서 다운로드
          </a>
          <br />
          <br />
          <br />
          <br />
        </div>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '접수완료' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default CmsRegistrationForm;
